import React from "react";
import AutoCompleteMultiple from "./AutoCompleteMultiple";

type SubgroupSelectorProps = {
  controlId: string;
  allowSubgroupSelection: boolean;
  subgroupHelperText: string;
  subgroupDisabled: boolean;
  subgroupOptions: string[];
  selectedAnimalSubgroups: string[];
  setSelectedAnimalSubgroups: (newValue: string[] | undefined) => void;
  subgroupSelectionLimit: number;
  maxSelectableFallback: number;
  formatSubgroupLabel: (value: string) => string;
  animalSubgroupsLoading: boolean;
  animalSubgroupsError: string | null;
  selectedAnimalsCount: number;
  subgroupDisabledReason: string;
  className?: string;
};

const SubgroupSelector = ({
  controlId,
  subgroupDisabled,
  subgroupOptions,
  selectedAnimalSubgroups,
  setSelectedAnimalSubgroups,
  subgroupSelectionLimit,
  maxSelectableFallback,
  formatSubgroupLabel,
 
}: SubgroupSelectorProps) => (
  <AutoCompleteMultiple
    id={controlId}
    label="Age Groups"
    options={subgroupOptions}
    disabled={subgroupDisabled}
    value={selectedAnimalSubgroups}
    setValue={setSelectedAnimalSubgroups}
    maxToSelect={
      subgroupSelectionLimit > 0
        ? subgroupSelectionLimit
        : maxSelectableFallback
    }
    formatOptionLabel={formatSubgroupLabel}
    formatTagLabel={formatSubgroupLabel}
  />
);

export default SubgroupSelector;
